import ResponsiveStyleSheet from "react-native-media-query";
import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";

export const { styles, ids } = ResponsiveStyleSheet.create({
  dropdown: createResponsiveStyles({
    base: {
      position: "relative",
      flex: 1,
      color: theme.colors.dark.base,
      marginTop: theme.spacing.small,
    },
    medium: {
      marginTop: theme.spacing.xlarge,
    },
  }),
  manualLink: {
    display: "flex",
    alignItems: "flex-end",
    marginTop: theme.spacing.small,
  },
  autoLink: {
    justifyContent: "center",
    marginTop: theme.spacing.small,
  },
});
